import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import CmsGlobalSearch from './GetCmsGlobalSearch.gql';

export const useGetCmsGlobalSearch = (options) => {
  return useQuery(CmsGlobalSearch, {
    ...options,
    url: ApiUrl.graphQl(),
  });
};
